import { render, staticRenderFns } from "./ApiUsage.vue?vue&type=template&id=2d4fa15c&scoped=true"
import script from "./ApiUsage.vue?vue&type=script&lang=js"
export * from "./ApiUsage.vue?vue&type=script&lang=js"
import style0 from "./ApiUsage.vue?vue&type=style&index=0&id=2d4fa15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4fa15c",
  null
  
)

export default component.exports